import { Pagination } from '@react-bootstrap/pagination'
import React, { Component } from 'react'

class CustomPagination extends Component {
  render() {
    const { items, totalPages, maxButtons, activePage } = this.props
    if (totalPages === 1 || !activePage) return null
    return (
      <div className="paginator">
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          items={totalPages || items}
          maxButtons={maxButtons}
          activePage={activePage}
          onSelect={this.props.onClickItem}
        />
      </div>
    )
  }
}

export default CustomPagination
